<template>
  <v-container :class="containerClass" fluid>
    <v-row>
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="itemList.data"
          :loading="isLoading"
          :options.sync="options"
          :server-items-length="itemList.meta.total"
          :footer-props="defaultDataTableFooterProps"
          item-key="id"
        >
          <template #top>
            <v-sheet>
              <v-container fluid class="pa-4">
                <v-row align="center">
                  <v-col md="6" cols="12">
                    <h2>Classroom List</h2>
                  </v-col>
                  <v-col md="6" cols="12" class="text-right">
                    <v-btn
                      v-if="hasPermission('classrooms.create')"
                      color="primary"
                      class="mx-1"
                      :small="$vuetify.breakpoint.mobile"
                      :href="$route('classrooms.create')"
                    >
                      <v-icon :small="$vuetify.breakpoint.mobile" left
                        >mdi-plus</v-icon
                      >Tambah
                    </v-btn>
                    <v-btn
                      class="mx-1"
                      :small="$vuetify.breakpoint.mobile"
                      @click="showFilters = !showFilters"
                    >
                      <v-icon :small="$vuetify.breakpoint.mobile" left
                        >mdi-filter</v-icon
                      >{{ showFilters ? 'Hide' : 'Show' }} Filter
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-sheet>
            <v-divider></v-divider>
            <v-expand-transition>
              <v-sheet v-show="showFilters" color="grey lighten-5">
                <v-container fluid class="pa-4">
                  <v-row>
                    <v-col v-if="!isTeacherAccount" md="2" cols="12">
                      <div class="label mb-2">Subscription Package</div>
                      <v-autocomplete
                        v-model="filters.subscription_package_id"
                        :items="subscriptionPackages"
                        item-text="name"
                        item-value="id"
                        :loading="isSubscriptionPackageListLoading"
                        outlined
                        solo
                        flat
                        background-color="white"
                        label="Subscription Package"
                        hide-details
                        dense
                        clearable
                        @change="getListData"
                        @click:clear="getListData"
                      />
                    </v-col>
                    <v-col v-if="!isStudentAccount" md="2" cols="12">
                      <div class="label mb-2">Student</div>
                      <v-autocomplete
                        v-model="filters.student_id"
                        :items="students"
                        item-text="name"
                        item-value="id"
                        :loading="isStudentListLoading"
                        :search-input.sync="searchInputStudent"
                        outlined
                        solo
                        flat
                        background-color="white"
                        label="Student"
                        hide-details
                        dense
                        clearable
                        cache-items
                        @change="getListData"
                        @click:clear="getListData"
                      />
                    </v-col>
                    <v-col md="2" cols="12">
                      <div class="label mb-2">Lesson Plan</div>
                      <v-autocomplete
                        v-model="filters.lesson_plan_id"
                        :items="lessonPlans"
                        item-text="name"
                        item-value="id"
                        :loading="isLessonPlanListLoading"
                        outlined
                        solo
                        flat
                        background-color="white"
                        label="Lesson Plan"
                        hide-details
                        dense
                        clearable
                        @change="getListData"
                        @click:clear="getListData"
                      />
                    </v-col>
                    <v-col v-if="!isTeacherAccount" md="2" cols="12">
                      <div class="label mb-2">Teacher</div>
                      <v-autocomplete
                        v-model="filters.teacher_id"
                        :items="teachers"
                        item-text="name"
                        item-value="id"
                        :loading="isTeacherListLoading"
                        outlined
                        solo
                        flat
                        background-color="white"
                        label="Teacher"
                        hide-details
                        dense
                        clearable
                        @change="getListData"
                        @click:clear="getListData"
                      />
                    </v-col>
                    <v-col md="2" cols="12">
                      <div class="label mb-2">Class Type</div>
                      <v-select
                        v-model="filters.class_type"
                        :items="classTypeOptions"
                        outlined
                        solo
                        flat
                        background-color="white"
                        label="Class Type"
                        hide-details
                        dense
                        clearable
                        @change="getListData"
                        @click:clear="getListData"
                      />
                    </v-col>
                    <v-col md="2" cols="12">
                      <div class="label mb-2">Status</div>
                      <v-select
                        v-model="filters.status"
                        :items="classStatusOptions"
                        outlined
                        solo
                        flat
                        background-color="white"
                        label="Status"
                        hide-details
                        dense
                        clearable
                        @change="getListData"
                        @click:clear="getListData"
                      />
                    </v-col>
                    <v-col md="2" cols="12">
                      <div class="label mb-2">Start Date</div>
                      <date-picker
                        v-model="filters.start_date"
                        value-type="format"
                        type="date"
                        range
                        class="mx-datepicker--dense"
                        confirm
                        @confirm="getListData"
                        @clear="getListData"
                      ></date-picker>
                    </v-col>
                    <v-col md="2" cols="12">
                      <div class="label mb-2">End Date</div>
                      <date-picker
                        v-model="filters.end_date"
                        value-type="format"
                        type="date"
                        range
                        class="mx-datepicker--dense"
                        confirm
                        @confirm="getListData"
                        @clear="getListData"
                      ></date-picker>
                    </v-col>
                    <v-col v-if="isEmployeeAccount" md="2" cols="12">
                      <div class="label mb-2">Created At</div>
                      <date-picker
                        v-model="filters.created_at"
                        value-type="format"
                        type="datetime"
                        range
                        class="mx-datepicker--dense"
                        confirm
                        @confirm="getListData"
                        @clear="getListData"
                      ></date-picker>
                    </v-col>
                    <v-col v-if="isEmployeeAccount" md="2" cols="12">
                      <div class="label mb-2">Updated At</div>
                      <date-picker
                        v-model="filters.updated_at"
                        value-type="format"
                        type="datetime"
                        range
                        class="mx-datepicker--dense"
                        confirm
                        @confirm="getListData"
                        @clear="getListData"
                      ></date-picker>
                    </v-col>
                  </v-row>
                </v-container>
                <v-divider></v-divider>
              </v-sheet>
            </v-expand-transition>
          </template>
          <template #[`item.code`]="{ item }">
            <strong>{{ item.code }}</strong>
          </template>
          <template #[`item.teacher`]="{ item }">
            {{ item.teacher.name }}
          </template>
          <template #[`item.subscription_package`]="{ item }">
            {{ item.subscription_package.name }}
          </template>
          <template #[`item.class_type`]="{ item }">
            {{ classroomTypeProps(item.class_type, 'text') }}
          </template>
          <template #[`item.students`]="{ item }">
            <ul v-for="(student, idx) in item.students" :key="idx">
              <li>{{ student.name }}</li>
            </ul>
          </template>
          <template #[`item.status`]="{ item }">
            <v-chip
              :color="classroomStatusProps(item.status, 'color')"
              small
              dark
            >
              <strong>
                {{ classroomStatusProps(item.status, 'text') }}
              </strong>
            </v-chip>
          </template>
          <template #[`item.created_at`]="{ item }">
            {{ formatDate(item.created_at, 'YYYY-MM-DD HH:mm:ss') }}
          </template>
          <template #[`item.updated_at`]="{ item }">
            {{ formatDate(item.updated_at, 'YYYY-MM-DD HH:mm:ss') }}
          </template>
          <template #[`item.action`]="{ item }">
            <div class="text-right">
              <v-btn
                v-if="hasPermission('classrooms.view')"
                small
                color="secondary"
                class="ma-1"
                :icon="$vuetify.breakpoint.mobile"
                :href="$route('classrooms.detail', item.id)"
              >
                <v-icon small>mdi-eye</v-icon>
                <span v-if="!$vuetify.breakpoint.mobile">&nbsp;View</span>
              </v-btn>
              <v-btn
                v-if="hasPermission('classrooms.update')"
                small
                color="warning"
                class="ma-1"
                :icon="$vuetify.breakpoint.mobile"
                :href="$route('classrooms.update', item.id)"
              >
                <v-icon small>mdi-pencil</v-icon>
                <span v-if="!$vuetify.breakpoint.mobile">&nbsp;Edit</span>
              </v-btn>
              <v-btn
                v-if="hasPermission('classrooms.delete')"
                small
                color="error"
                class="ma-1"
                :icon="$vuetify.breakpoint.mobile"
                @click="showDeleteDialog(item)"
              >
                <v-icon small>mdi-delete-forever</v-icon>
                <span v-if="!$vuetify.breakpoint.mobile">&nbsp;Delete</span>
              </v-btn>
            </div>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <classroom-delete-dialog
      v-if="deleteDialog.show"
      v-model="deleteDialog.show"
      :classroom="deleteDialog.item"
      @delete="getListData"
    ></classroom-delete-dialog>
  </v-container>
</template>
<script>
import LayoutDashboard from '@layouts/Dashboard'
import ClassroomDeleteDialog from '@components/Classroom/DeleteDialog'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import constant from '@/constant'
import { ListParams } from '@/models'
import utils from '@/utils'

export default {
  name: 'Classroom',
  components: {
    ClassroomDeleteDialog,
  },
  layout: LayoutDashboard,
  data() {
    return {
      options: {
        page: 1,
        itemsPerPage: 10,
      },
      showFilters: true,
      filters: {
        name: null,
        subscription_package_id: null,
        lesson_plan_id: null,
        teacher_id: null,
        student_id: null,
        class_type: null,
        status: null,
        created_at: [],
        updated_at: [],
        start_date: [],
        end_date: [],
      },
      deleteDialog: {
        show: false,
        item: null,
      },
      searchInputStudent: null,
    }
  },
  computed: {
    ...mapGetters({
      itemList: 'classroom/list',
      isLoading: 'classroom/isListLoading',
      teacherList: 'teacher/list',
      isTeacherListLoading: 'teacher/isListLoading',
      lessonPlanList: 'lessonPlan/list',
      isLessonPlanListLoading: 'lessonPlan/isListLoading',
      subscriptionPackageList: 'subscriptionPackage/list',
      isSubscriptionPackageListLoading: 'subscriptionPackage/isListLoading',
      studentList: 'student/searchList',
      isStudentListLoading: 'student/isSearchListLoading',
      authUser: 'authUser',
      isTeacherAccount: 'isTeacherAccount',
      hasPermission: 'hasPermission',
      listParams: 'classroom/listParams',
    }),
    classTypeOptions() {
      return constant.classroomTypeOptions
    },
    classStatusOptions() {
      return constant.classroomStatusOptions
    },
    teachers() {
      return this.teacherList.data
    },
    lessonPlans() {
      return this.lessonPlanList.data
    },
    subscriptionPackages() {
      return this.subscriptionPackageList.data
    },
    students() {
      return this.studentList.data
    },
    headers() {
      return [
        { text: 'ID', value: 'code', sortable: false },
        { text: 'Name', value: 'name' },
        {
          text: 'Subscription Package',
          value: 'subscription_package',
          sortable: false,
        },
        ...(this.isTeacherAccount === false
          ? [{ text: 'Teacher', value: 'teacher', sortable: false }]
          : []),
        { text: 'Class Type', value: 'class_type', sortable: false },
        { text: 'Start Date', value: 'start_date' },
        { text: 'End Date', value: 'end_date' },
        ...(this.isStudentAccount === false
          ? [
              {
                text: 'Students',
                value: 'students',
                sortable: false,
              },
            ]
          : []),
        {
          text: 'Status',
          value: 'status',
          sortable: false,
        },
        ...(this.isEmployeeAccount
          ? [
              {
                text: 'Created At',
                value: 'created_at',
              },
              {
                text: 'Updated At',
                value: 'updated_at',
              },
            ]
          : []),
        { text: 'Action', value: 'action', sortable: false, align: 'center' },
      ]
    },
  },
  watch: {
    options: {
      deep: true,
      handler() {
        this.getListData()
      },
    },
    searchInputStudent(val) {
      if (val) {
        this.debouncedSearchStudentList()
      }
    },
  },
  created() {
    this.init()
    this.debouncedSearchStudentList = _.debounce(this.searchStudentList, 500)
  },
  methods: {
    ...mapActions({
      getItemList: 'classroom/getList',
      getTeacherList: 'teacher/getList',
      getLessonPlanList: 'lessonPlan/getList',
      getSubscriptionPackageList: 'subscriptionPackage/getList',
      getStudentList: 'student/search',
    }),
    ...mapMutations({
      setListParams: 'classroom/setListParams',
    }),
    init() {
      if (this.isTeacherAccount) {
        this.filters.teacher_id = this.authUser.account_id
        this.filters.status = 'ACTIVE'
      } else {
        this.getTeacherList()
      }
      if (this.isStudentAccount) {
        this.filters.student_id = this.authUser.account_id
        this.filters.status = 'ACTIVE'
      }
      this.getLessonPlanList()
      this.getSubscriptionPackageList()
      if (this.listParams) {
        _.merge(this.filters, this.listParams.filters)
        _.merge(this.options, this.listParams.options)
      }
    },
    getListData() {
      const listParams = new ListParams(this.filters, this.options)
      this.getItemList(utils.toServerSideQuery(listParams))
      this.setListParams(listParams)
    },
    showDeleteDialog(item) {
      this.deleteDialog.item = item
      this.deleteDialog.show = true
    },
    searchStudentList() {
      this.getStudentList({ search: this.searchInputStudent })
    },
  },
}
</script>
